import { Component, Input, OnInit } from '@angular/core';
import { AppService } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';

@Component({
  selector: 'app-events-table',
  templateUrl: './events-table.component.html',
  styleUrls: ['./events-table.component.scss'],
})
export class EventsTableComponent implements OnInit {
  @Input() data: ApolusTypes.ApolusEventsTable[];

  events: ApolusTypes.ApolusEventsTable[] = [
    { AlarmDescription: 'Fuga', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Alto consumo', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Tubo vacío', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Flujo reverso', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Fuera de rango', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Temperatura', Quantity: 100, Percentage: 100 },
    { AlarmDescription: 'Batería baja', Quantity: 100, Percentage: 100 },
  ];

  constructor(
    public _appService: AppService,
    public _apolusService: ApolusService,
    public _gearAppService: GearAppService
  ) {}

  ngOnInit(): void {
    if (!this.data || this.data.length === 0) {
      this.data = this.events;
    }
  }

}
